import { modifier } from 'ember-modifier';

type ClickOutsideHandler = (event: MouseEvent) => void;

/**
 * The only click-outside behavior used in the workspace: invoke a callback
 * when a document click lands outside the modified element.
 */
export default modifier((element: HTMLElement, [handler]: [ClickOutsideHandler]) => {
  const onDocumentClick = (event: MouseEvent) => {
    const path = event.composedPath();
    if (path.includes(element)) {
      return;
    }

    // Ignore events whose target was removed before document handled them;
    // their inside/outside relationship can no longer be determined.
    if (!(event.target instanceof Node) || !document.contains(event.target)) {
      return;
    }

    handler(event);
  };

  // Defer registration so the click that opened the popover cannot also
  // close it while that same event is still bubbling.
  let active = true;
  queueMicrotask(() => {
    if (active) {
      document.addEventListener('click', onDocumentClick);
    }
  });

  return () => {
    active = false;
    document.removeEventListener('click', onDocumentClick);
  };
});
